<div class="wrapper">
  <ng-select class="dropdown-panel-timezone"
             [ngModel]="setDefaultValue()"
             (change)="onSelected($event)"
             [disabled]="isDisabled()"
             [clearable]="isClearable()"
             [items]="timezones"
             [groupBy]="group()"
             [searchFn]="searchFn"
             bindLabel="name"
             [placeholder]="customPlaceholderText()">
  </ng-select>
</div>
